//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CommonImg from '@/components/views/common_img'
import { getBanner } from './utils'

export default {
    data () {
        return {
            swiper_list: [
                {
                    img_url: getBanner('weixin-official'),
                    url: 'https://mp.weixin.qq.com/s/TwXq2pcpbYLFUucQC2P2BA'
                }
            ]
        }
    },
    methods: {
        changeSwiper (s) {
        },
        tapSwiper (i) {
        }
    },
    components: {
        CommonImg
    },
    props: {
    }
}
